import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

require('./plugins');

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
